import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
export var BalanceOf = createPlugin({
    protocol: 'ERC1155',
    type: 'GETTER',
    method: 'balanceOf',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc1155' }),
                methodParams: {
                    account: new FctAddress({}),
                    id: new FctValue({}),
                },
            },
            output: {
                balance: new FctValue({ destination: 'wei_amount', innerIndex: 0 }),
            },
        });
    },
});
